import { makeStyles } from '@mui/styles';

const useTopBarStyle = makeStyles(() => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    background:'#4565B7'
  },
  title: {
    flexGrow: 1,
    fontWeight: 'bold',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '@media (max-width: 899px)': {
      textAlign: 'center',
    },
  },
  select: {
    color: 'black',
    backgroundColor: 'white',
    borderRadius: 4,
    minWidth: 100,
  },
  hamburger: {
    display: 'block',
    '@media (min-width: 900px)': {
      display: 'none',
    },
  },
}));

export default useTopBarStyle;
